var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicGAppArrowLeft = function SvgIcLogicGAppArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.3 22.2c-.3 0-.5-.1-.7-.3L9.7 15l6.9-6.9c.4-.4 1-.4 1.4 0s.4 1 0 1.4L12.5 15l5.5 5.5c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h30v30H0z"
  })));
};
export default SvgIcLogicGAppArrowLeft;